<template>
  <aside :style="!(asideRightBl || isNoMenus || isCollapse) ? {width: '232px'} : {width: '56px'}">
    <Apps :apps="microAppRoutes" @panelChange="panelChange" />
    <div
      :style="!(asideRightBl || isNoMenus || isCollapse) ? {width: '176px'} : {width: 0}"
      class="aside-right"
    >
      <Search :collapse="isCollapse" v-bind="{ product }" />
      <iw-scrollbar
        wrap-class="scrollbar-wrapper"
        style="height: calc(100% - 148px)"
      >
        <iw-menu
          v-if="product.children && product.children.length"
          id="leftMenu"
          :text-color="variables.menuText"
          :default-openeds="product.children.map((item) => item.id)"
          mode="vertical"
          class="iw-menu-vertical-demo"
        >
          <SidebarItem
            v-for="item in product.children"
            :key="item.id"
            :public-path="product.path"
            :item="item"
          />
        </iw-menu>
      </iw-scrollbar>
    </div>
    <div
      v-if="!(asideRightBl || isNoMenus)"
      class="menu-close"
      :style="{ left: `${sidebar.opened ? 232 : 56}px` }"
      @click="onSiderbarClick"
    >
      <svg-icon icon-class="menu-close" class-name="menu-close-block" />
      <a-icon
        class="menu-close-left"
        type="double-left"
        :style="{
          transform: `translateY(-50%) rotate(${sidebar.opened ? 0 : 180}deg)`,
        }"
      />
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import { PermissionFilterBl } from "@/utils/filters";
import variables from "@/styles/variables.scss";
import Apps from "./apps";
import Search from "./search";
import SidebarItem from "./SidebarItem";
import $ from "jquery";
import { parseUrl } from "@/utils/helper";
import { mapActions } from "vuex";
import actions from "@/utils/actions";
import moment from "moment";

export default {
  components: {
    Apps,
    Search,
    SidebarItem,
  },
  data() {
    return {
      asideRightBl: PermissionFilterBl(this.$router.history._startLocation), // 用于显示部分不需要受越权
    };
  },
  computed: {
    ...mapGetters(["sidebar", "microAppRoutes"]),
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    publicPath() {
      let { path, query } = this.$route;
      path = path.split("/").slice(0, 2).join("/");

      if (query && query.product) {
        return decodeURIComponent(query.product);
      }
      return path;
    },
    product() {
      const product =
        this.microAppRoutes.find((item) => {
          let path = item.path;
          if (path.indexOf("product") > -1) {
            const urls = parseUrl(path);
            path = decodeURIComponent(urls.query.product);
          }
          return path === this.publicPath;
        }) || {};
      return product;
    },
    isNoMenus() {
      return ["multidimensional-query", "sq"].some(
        (n) => this.$route.path.indexOf(n) > -1
      );
    },
  },
  watch: {
    $route() {
      this.clickMenuItem();
    },
  },
  mounted() {
    this.clickMenuItem();
  },
  methods: {
    ...mapActions("app", ["toggleSideBar"]),
    onSiderbarClick() {
      actions.setGlobalState({
        sidebar: {
          opened: !this.sidebar.opened,
        },
        time: moment().format("yyyy.MM.DD HH:mm:ss"),
      });
      this.toggleSideBar();
    },
    panelChange(value) {
      this.$emit("panelChange", value);
    },
    clickMenuItem() {
      setTimeout(() => {
        const menuItems = $("#leftMenu a");
        const ActiveMenuItems = $("#leftMenu a.router-link-active");

        if (ActiveMenuItems.length === 0) {
          const item = menuItems[0];
          if (item) {
            const url = item.getAttribute("href");
            this.$router.replace(url);
          }
        }
      }, 100);
    },
  },
};
</script>
